import { Component, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs';
import {
  concatMap, map, take, tap
} from 'rxjs/operators';

import { AppCustomLine as CustomLine } from 'graphql/models/extended';
import { OfferPositionService } from 'shared/services/offer-position.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-loose-categories-modal',
  templateUrl: './loose-categories-modal.component.html',
  styleUrls: ['./loose-categories-modal.component.scss']
})
export class LooseCategoriesModalComponent {
  @Output() onSelectedItem = new EventEmitter<string>();

  constructor(
    private offerPositionService: OfferPositionService,
    private storeService: StoreService
  ) {}

  onSelectItem(id: string): void {
    this.onSelectedItem.emit(id);
  }

  onSubmit(): Observable<any> {
    return this.storeService.getCurrentOffer()
      .pipe(
        take(1),
        concatMap((offer) => this.offerPositionService.addCustomPositionCustomToOffer(offer)
          .pipe(map((customLines: CustomLine[]) => ({ offer, customLines })))),
        concatMap(({ offer, customLines }) => this
          .offerPositionService.getPosition(offer, customLines[0].id) as Observable<CustomLine>),
        tap((position) => this.storeService.setCustomPosition(position))
      );
  }
}
